import { render, staticRenderFns } from "./PointsExchangeView.vue?vue&type=template&id=c9238e4a&scoped=true"
import script from "./PointsExchangeView.vue?vue&type=script&lang=js"
export * from "./PointsExchangeView.vue?vue&type=script&lang=js"
import style0 from "./PointsExchangeView.vue?vue&type=style&index=0&id=c9238e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9238e4a",
  null
  
)

export default component.exports